export const timeAgo = (inputDate) => {
    const date = new Date(inputDate);
    const now = new Date();

    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) {
        return `${seconds} seconde${seconds > 1 ? 's' : ''}`;
    }

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return `${hours} heure${hours > 1 ? 's' : ''}`;
    }

    const days = Math.floor(hours / 24);
    if (days < 30) {
        return `${days} jour${days > 1 ? 's' : ''}`;
    }

    const months = Math.floor(days / 30);
    if (months < 12) {
        return `${months} mois`;
    }

    const years = Math.floor(months / 12);
    return `${years} an${years > 1 ? 's' : ''}`;
};


